// import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import * as html2pdf from 'html2pdf.js';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
// import { HttpErrorResponse } from '@angular/common/http';
import { toWords } from 'number-to-words';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-payment-receipt',
  templateUrl: './payment-receipt.component.html',
  styleUrls: ['./payment-receipt.component.scss']
})
export class PaymentReceiptComponent implements OnInit {
  @ViewChild('contentToConvert') contentToConvert!: ElementRef;
  src;
  payHistory: FormGroup;
  payHistoryData: any;
  addmissionData: any;
  clgName: any;
  CoName: any;
  SnNo: any;
  FeeTable: any;
  personaldetails: any;
  TotalPaidAmountInWords: any;
  PreFix: any;
  formattedPrn: any;
  Transcript: boolean;
  TranscriptData: any;
  StuName: any;
  RegnNo: any;
  TransactionId: any;
  isAttestation: boolean = false;
  isVOD: boolean = false;  // Added for VOD
  isTranscript: boolean = false; // Added for Transcript
  constructor(private fb: FormBuilder, public umsService: UmsService,
    public dialogRef1: MatDialogRef<PaymentReceiptComponent>,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  // listOfFee: any;
  tempCo
  StudentPersonalId
  InstuName
  currentDate
  FirstName: string
  MiddleName: string
  LastName: string
  Number: number
  Email: string
  StudentId
  feeMode
  payModeee
  TotalPaidAmount
  showDownloadButton = true;
  generatingPDF = false;
  downloadingPDF: boolean = true;
  Currency
  reciptNumber
  RgNo
  // payHistoryData: any;
  ngOnInit(): void {
    this.getSecretData();
    this.getUserData(sessionStorage.getItem('StudentRGID'))
    this.prepopulationOfAddmission();
    this.currentDate = new Date();
    this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentPersonalId = sessionStorage.getItem('StuId');
    this.tempCo = sessionStorage.getItem('TemplateCode');
    this.StudentId = sessionStorage.getItem('StuId');
    this.feeMode = sessionStorage.getItem('FeeMode');
    sessionStorage.getItem('StudentRGID');

  }

  transPRN(RgNo) {

    this.formattedPrn = this.data.RgNo.toString().padStart(8, '0');
  }


  getData() {
    this.spinner.show();
    const payload = {};
    payload['TemplateCode'] = this.tempCo != null ? this.tempCo : this.data.TemplateCode
    payload['FeeType'] = ''
    // this.disablePaid = true;
    this.umsService.getFeeTemplet(payload).subscribe((res) => {
      this.spinner.hide()
      let data = res.data[0];
      this.Currency = res.data[0].Currency
      if (res.status) {
        this.FeeTable = res.data;
      } else {
        // this.umsService.openSnackbar(res.message);
      }
    });
  }


  downloadAsPDF() {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    const filename = `PaymentReceipt_${formattedDate}.pdf`;

    const options = {
      filename: filename,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    const element = this.contentToConvert.nativeElement;
    const buttons = element.querySelectorAll('button');
    buttons.forEach(button => {
      button.style.display = 'none';
    });

    html2pdf()
      .from(element)
      .set(options)
      .save()
      .then(() => {
        // Restore the visibility of the buttons after PDF generation is complete
        buttons.forEach(button => {
          button.style.display = '';
        });
      });
  }


  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.SnNo = res.projectPharam['SnNo']
      if (this.data.FeeType === 'TS') {
        this.isAttestation = false;
        this.isVOD = false;
        this.isTranscript = true;
        this.getTranscriptHistory()
        this.getTranscript()
      }
      else if (this.data.FeeType === 'ATTFE') {
        this.isAttestation = true;                 // NEW: enable attestation details block
        this.isVOD = false;
        this.isTranscript = false;
        this.getTranscriptHistory()
        this.getTranscript()                       // populate TranscriptData
        this.Transcript = false;                   // use simple fee table, not styled transcript table
      }
      else if (this.data.FeeType === 'VOD') {
        this.isAttestation = false;
        this.isVOD = true;
        this.isTranscript = false;
        this.getTranscriptHistory()
        this.getTranscript()                       // populate TranscriptData
        this.Transcript = false;                   // use simple fee table, not styled transcript table
      }
      else {
        this.Transcript = false;
        this.getHistory(res.projectPharam['SnNo']);
      }
      this.InstuName = res.projectPharam['InstituteName']
      this.getData();
    })
  }
  getHistory(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['FeeTemplateCode'] = this.tempCo != null ? this.tempCo : this.data.TemplateCode;
    payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : this.data.StuId;
    payload['FeeHistory'] = 1;
    payload['SnNo'] = this.data.Session != null ? this.data.Session : this.data.SnNo;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {

      this.spinner.hide();
      let data = res.data;
      if (payload['FeeTemplateCode'] == 'ASC') {
        const filtered = res.data.filter((it: any) => it.StuSubId === this.data.StuSubId);
        if (filtered.length) {
          data = filtered;
        }
      }

      // Guarded PaymentResponseId filter for ASC / ATTFE / VOD
      if (this.data.CertType == 'ASC' && this.data.PaymentResponseId) {
        const filtered = data.filter((it) => it.PaymentResponseID == this.data.PaymentResponseId);
        if (filtered.length) {
          data = filtered;
        }
      }
      if (this.data.FeeType === 'ATTFE' && this.data.PaymentResponseId) {
        data = data.filter((it) => it.PaymentResponseID == this.data.PaymentResponseId);
      }
      if (this.data.FeeType === 'VOD' && this.data.PaymentResponseId) {
        data = data.filter((it) => it.PaymentResponseID == this.data.PaymentResponseId);
      }

      this.payHistoryData = data;

      this.TransactionId = this.payHistoryData[0]?.TransactionId;
      if (!this.payHistoryData[0]?.card_type) {
        this.payModeee = 'Online Payment';
      } else {
        this.payModeee = this.payHistoryData[0].card_type;
      }

      this.reciptNumber = this.payHistoryData[0]?.PaymentResponseID || this.generateSingleFiveDigitReceiptNumber();
      if (res.data[0]?.FeeType == "EF") {
        // this.Currency =  sessionStorage.getItem('ExamCurrency')
      }
      else {
        // this.Currency = sessionStorage.getItem('Currency')
      }

      if (payload['FeeTemplateCode'] == 'ASC') {

        this.TotalPaidAmount = this.payHistoryData.reduce(
          (sum, item) => sum + (Number(item.FeeAmt) || Number(item.FeeAmount) || 0), 0
        );
      } else {
        this.TotalPaidAmount = this.payHistoryData[0]?.TotalPaidAmount
          || this.payHistoryData.reduce((sum, item) => sum + (Number(item.FeeAmt) || Number(item.FeeAmount) || 0), 0);
      }

      this.convert(this.TotalPaidAmount)
    })

  }
  convert(number) {
    this.TotalPaidAmountInWords = toWords(number);
  }

  getUserData(id) {
    this.FirstName = ''
    this.MiddleName = ''
    this.LastName = ''
    this.Number = 0
    this.Email = ''
  }
  close() {
    this.dialogRef1.close();
  }


  prepopulationOfAddmission() {
    // this.spinner.show();
    this.StudentPersonalId = sessionStorage.getItem("StudentPersonalId");
    let payload = {};
    payload['StuId'] = this.data.StuId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.addmissionData = res.data[0];
        this.getclg(res.data[0]);
        this.getCourse(res.data[0])
      }
    })

    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        this.personaldetails = res.data[0];
        this.FirstName = res.data[0]['StuFirstNameEng']
        this.MiddleName = res.data[0]['StuMidNameEng']
        this.LastName = res.data[0]['StuLastNameEng']
        this.RgNo = res.data[0]['StuRgNo']
        this.transPRN(this.RgNo)
      }
      else {
        this.clgName = this.data.College;
        this.CoName = this.data.Course;
        this.StuName = this.data.StuName;
        this.PreFix = ''
        this.transPRN(this.RgNo);

      }
    })

  }

  getclg(data) {
    let payload = {};
    payload['CgCode'] = data.StuCgId
    this.umsService.getCollege(payload).subscribe((res) => {
      if (res.status) {
        this.clgName = res.data[0].CgName
      }
      else {
        this.clgName = this.data.College;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.clgName = this.data.College;
    })

  }


  getCourse(data) {
    let payload = {};
    payload['CoCode'] = data.StuCoId
    this.umsService.fetchCourseType(payload).subscribe((res) => {
      if (res.status) {
        this.CoName = res.data[0].CoName
        this.PreFix = res.data[0].CoRgPrfx
      }
      else {
        this.CoName = this.data.Course;
        this.PreFix = ''
      }

    }, (ERROR: HttpErrorResponse) => {
      this.CoName = this.data.Course;
      this.PreFix = ''
    })

  }


  generateSingleFiveDigitReceiptNumber(): string {
    const randomNumber = Math.floor(Math.random() * 100000); // Generate random number between 0 and 99999
    const formattedNumber = randomNumber.toString().padStart(5, '0'); // Ensure it's formatted to have 5 digits with leading zeros
    return formattedNumber;
  }

  // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
  isStudentWithinIndia(): boolean {
    if (!this.TranscriptData) {
      return true;
    }

    const deliverAt = (this.TranscriptData?.DeliverAt || '').toString().trim().toUpperCase();
    if (deliverAt === 'IN' || deliverAt === 'INDIA') {
      return true;
    }
    if (deliverAt === 'OFI' || deliverAt === 'OUT' || deliverAt === 'OUTSIDE') {
      return false;
    }

    const country = (this.TranscriptData?.Country || this.TranscriptData?.CountryName ||
      this.TranscriptData?.StuCountry || this.TranscriptData?.StuCountryName || '')
      .toString().trim().toLowerCase();

    // If the country/delivery location is not available, consider the student as within India (no postal charges)
    if (!country) {
      return true;
    }

    return country === 'india' || country === 'ind' || country === 'in' || country === 'bharat';
  }

  // getTranscriptHistory(){
  //   this.spinner.show();
  //   let payload = {};
  //   payload['FeeTemplateCode'] = this.tempCo != null ? this.tempCo : this.data.TemplateCode;
  //   payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : this.data.StuId;
  //   payload['FeeHistory'] = 0;
  //   payload['SnNo'] =this.data.Session != null ? this.data.Session : this.data.SnNo;
  //   this.umsService.getSearchTranscriptFeeDetails(payload).subscribe((res) => {
  //     this.spinner.hide();
  //     this.payHistoryData = res.data;
  //      if(res.data[0].card_type == ""){
  //       this.payModeee = 'Online Payment'
  //     }
  //     else{
  //       this.payModeee = res.data[0].card_type;
  //     }
  //     this.reciptNumber = res.data[0].PaymentResponseID;
  //     if (res.data[0].FeeType == "EF") {
  //       this.Currency =  sessionStorage.getItem('ExamCurrency')
  //     }
  //     else {
  //       // this.Currency = sessionStorage.getItem('Currency')
  //       this.Currency = this.Currency
  //     }

  //     this.TotalPaidAmount = res.data[0].TotalPaidAmount
  //     this.convert( this.TotalPaidAmount)
  //     const customOrder = [
  //       "Transcript Fee",
  //       "Base Amount",
  //       "Per Additional Set For Transcript",
  //       "Postal Charges",
  //       "Hard Copy",
  //       "Per Additional Set For Delivery",
  //       "Soft Copy",
  //     ];
      
  //     this.payHistoryData = this.payHistoryData.sort((a, b) => {
  //       const normalizeName = (name: string) => {
  //         // Handle dynamic names by removing the "(x Set)" part
  //         return name.replace(/\s*\(\d+\s*Set\)/, "");
  //       };
        
  //       const indexA = customOrder.indexOf(normalizeName(a.FeeHead));
  //       const indexB = customOrder.indexOf(normalizeName(b.FeeHead));
      
  //       // If a name is not in the customOrder array, push it to the end
  //       return (indexA === -1 ? customOrder.length : indexA) - 
  //              (indexB === -1 ? customOrder.length : indexB);
  //     });
  //   })
  // }
getTranscriptHistory() {
  this.spinner.show();
  const needTranscriptData =
    (this.data.FeeType === 'ATTFE' || this.data.FeeType === 'VOD') &&
    !this.TranscriptData;

  if (needTranscriptData) {

    const payload: any = {

      StuId:
        this.StudentPersonalId != null
          ? this.StudentPersonalId
          : this.data.StuId

    };

    this.umsService
      .SearchTranscript(payload)
      .subscribe((res) => {

        if (res.status) {

          this.TranscriptData =
            res.data[0];

          this.Transcript = true;

          this.RegnNo =
            res.data[0].StuPRN;

          this.clgName =
            res.data[0].College;

          this.CoName =
            res.data[0].Course;

          this.StuName =
            res.data[0].StuName;

          // Continue
          this.doGetTranscriptHistory();

        } else {

          this.spinner.hide();

        }

      });

  } else {

    this.doGetTranscriptHistory();

  }

}

private doGetTranscriptHistory() {

  let payload: any = {};

  payload['FeeTemplateCode'] =
    this.tempCo != null
      ? this.tempCo
      : this.data.TemplateCode;

  payload['StuId'] =
    this.StudentPersonalId != null
      ? this.StudentPersonalId
      : this.data.StuId;

  payload['FeeHistory'] = 0;

  payload['SnNo'] =
    this.data.Session != null
      ? this.data.Session
      : this.data.SnNo;

  this.umsService
    .getSearchTranscriptFeeDetails(payload)
    .subscribe((res) => {

      this.spinner.hide();

      let data = res.data;
      if (this.data.PaymentResponseId) {

        data = data.filter(
          (it: any) =>
            it.PaymentResponseID ==
            this.data.PaymentResponseId
        );

      }
   if (
        (this.data.FeeType === 'ATTFE' || this.data.FeeType === 'VOD') &&
        this.TranscriptData
      ) {

        this.payHistoryData = [];
        const copies =
          Number(
            this.TranscriptData.StuCertCopies
          ) || 0;

        const deliveryOpt =
          this.TranscriptData.DeliveryOpt;
        const BASE_AMOUNT = 3050;

        // Attestation/VOD Fee Per Copy - VOD has no copies fee
        const PER_COPY_FEE = this.isVOD ? 0 : 800;

        // Soft Copy Delivery Fee
        const SOFT_COPY_FEE = 800;

        // Hard Copy Base Fee
        const HARD_COPY_FEE = 2570;

        // Hard Copy Delivery Charges Per Copy - VOD has no per copy delivery
        const PER_COPY_DELIVERY = this.isVOD ? 0 : 800;

        // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
        const isIndiaStudent = this.isVOD ? this.isStudentWithinIndia() : false;

        let copiesFee = 0;

        let softCopy = 0;

        let hardCopy = 0;

        let perCopyDelivery = 0;

        let postalCharges = 0;

        let totalFee = 0;
        copiesFee =
          PER_COPY_FEE * copies;
        if (deliveryOpt === 'Soft') {

          softCopy =
            SOFT_COPY_FEE;

          postalCharges =
            softCopy;

        }
        else if (deliveryOpt === 'Hard') {

          // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
          hardCopy =
            (this.isVOD && isIndiaStudent) ? 0 : HARD_COPY_FEE;

          perCopyDelivery =
            (this.isVOD && isIndiaStudent) ? 0 : (PER_COPY_DELIVERY * copies);

          postalCharges =
            hardCopy +
            perCopyDelivery;

        }
        else if (deliveryOpt === 'Both') {

          softCopy =
            SOFT_COPY_FEE;

          // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
          hardCopy =
            (this.isVOD && isIndiaStudent) ? 0 : HARD_COPY_FEE;

          perCopyDelivery =
            (this.isVOD && isIndiaStudent) ? 0 : (PER_COPY_DELIVERY * copies);

          postalCharges =
            softCopy +
            hardCopy +
            perCopyDelivery;

        }
        totalFee =
          BASE_AMOUNT +
          copiesFee +
          postalCharges;
        const paymentDate =
          new Date();
        this.payHistoryData.push({

          FeeHead: this.isVOD ? 'Verification Fee' : 'Base Amount',

          FeeAmt: BASE_AMOUNT,

          FeePaymentDate: paymentDate

        });
        
        // Only add Copies Fee if not VOD or if copies fee > 0
        if (!this.isVOD && copiesFee > 0) {
          this.payHistoryData.push({

            FeeHead:
              `Copies Fee (${copies} Set)`,

            FeeAmt: copiesFee,

            FeePaymentDate: paymentDate

          });
        }
        
        // For VOD, show Copies Fee as Not Applicable
        if (this.isVOD) {
          this.payHistoryData.push({

            FeeHead:
              `Copies Fee`,

            FeeAmt: 0,

            FeePaymentDate: paymentDate

          });
        }
        
        if (softCopy > 0) {

          this.payHistoryData.push({

            FeeHead: this.isVOD ? 'By Email Charges' : 'By Email Charges Delivery Fee',

            FeeAmt: softCopy,

            FeePaymentDate: paymentDate

          });

        }
        if (hardCopy > 0) {

          this.payHistoryData.push({

            FeeHead: this.isVOD ? 'By Air Mail Charges' : 'By Air Mail Charges Delivery Fee',

            FeeAmt: hardCopy,

            FeePaymentDate: paymentDate

          });

        }
        if (perCopyDelivery > 0) {

          this.payHistoryData.push({

            FeeHead: this.isVOD ? 'Extra Hard Copy Delivery Charges' : ' Extra By Air Mail Charges Delivery Charges',

            FeeAmt: perCopyDelivery,

            FeePaymentDate: paymentDate

          });

        }
        // if (postalCharges > 0) {

        //   this.payHistoryData.push({

        //     FeeHead:
        //       'Postal Charges',

        //     FeeAmt: postalCharges,

        //     FeePaymentDate: paymentDate

        //   });

        // }
        this.TotalPaidAmount =
          totalFee;

        this.convert(
          this.TotalPaidAmount
        );
        if (data && data.length) {

          this.TransactionId =
            data[0]?.TransactionId;

          this.reciptNumber =
            data[0]?.PaymentResponseID;

          this.payModeee =
            data[0]?.card_type
              ? data[0].card_type
              : 'Online Payment';

        } else {

          this.reciptNumber =
            this.generateSingleFiveDigitReceiptNumber();

          this.payModeee =
            'Online Payment';

        }
        const customOrder = this.isVOD ? [

          'Verification Fee',

          'Copies Fee',

          'By Email Charges',

          'By Air Mail Charges',

          'Extra Hard Copy Delivery Charges',

          // 'Postal Charges'

        ] : [

          'Base Amount',

          'Copies Fee',

          'Soft Copy Delivery Fee',

          'Hard Copy Delivery Fee',

          'Extra Hard Copy Delivery Charges',

          // 'Postal Charges'

        ];

        this.payHistoryData.sort((a, b) => {

          const idxA =
            customOrder.findIndex(x =>
              a.FeeHead.includes(x));

          const idxB =
            customOrder.findIndex(x =>
              b.FeeHead.includes(x));

          return (
            (idxA === -1
              ? customOrder.length
              : idxA) -
            (idxB === -1
              ? customOrder.length
              : idxB)
          );

        });

      }
      else {

        this.payHistoryData = data;

        this.TransactionId =
          data[0]?.TransactionId;

        this.reciptNumber =
          data[0]?.PaymentResponseID;

        this.payModeee =
          data[0]?.card_type
            ? data[0].card_type
            : 'Online Payment';

        if (data[0]?.FeeType == "EF") {

          this.Currency =
            sessionStorage.getItem(
              'ExamCurrency'
            );

        } else {

          this.Currency =
            this.Currency;

        }

        this.TotalPaidAmount =
          data[0]?.TotalPaidAmount || 0;

        this.convert(
          this.TotalPaidAmount
        );
        const customOrder = [

          "Transcript Fee",

          "Base Amount",

          "Per Additional Set For Transcript",

          "Postal Charges",

          "Hard Copy",

          "Per Additional Set For Delivery",

          "Soft Copy",

        ];
        this.payHistoryData =
          this.payHistoryData.sort((a, b) => {

            const normalizeName =
              (name: string) =>
                name.replace(
                  /\s*\(\d+\s*Set\)/,
                  ""
                );

            const indexA =
              customOrder.indexOf(
                normalizeName(a.FeeHead)
              );

            const indexB =
              customOrder.indexOf(
                normalizeName(b.FeeHead)
              );

            return (
              (indexA === -1
                ? customOrder.length
                : indexA) -
              (indexB === -1
                ? customOrder.length
                : indexB)
            );

          });

      }

    });

}

  normalizeFeeHead(name: string): string {
    // Remove dynamic "(x Set)" part
    return name.replace(/\s*\(\d+\s*Set\)/, "");
  }

  isSubhead(feeHead: string): boolean {
    const normalized = this.normalizeFeeHead(feeHead);
    return [
      'Per Additional Set For Transcript',
      'Hard Copy',
      'Soft Copy',
      'Base Amount',
      'Per Additional Set For Delivery'
    ].includes(normalized);
  }

  isHead(feeHead: string): boolean {
    const normalized = this.normalizeFeeHead(feeHead);
    return ['Transcript Fee', 'Postal Charges'].includes(normalized);
  }
  // getTranscript(){
  //   let payload = {};
  //   payload['StuId'] = this.StudentPersonalId != null ? this.StudentPersonalId : this.data.StuId;
  //   this.umsService.SearchTranscript(payload).subscribe((res) => {
  //     if(res.status){
  //       this.TranscriptData = res.data[0]
  //       this.Transcript = true;
  //       this.RegnNo = res.data[0].StuPRN
  //       this.clgName = res.data[0].College
  //       this.CoName = res.data[0].Course
  //       this.StuName = res.data[0].StuName
  //     }
  //     else{

  //     }
  //   });
  // }
 getTranscript() {

  let payload: any = {};

  payload['StuId'] =
    this.StudentPersonalId != null
      ? this.StudentPersonalId
      : this.data.StuId;

  this.umsService
    .SearchTranscript(payload)
    .subscribe((res) => {

      if (res.status) {

        this.TranscriptData =
          res.data[0];

        this.Transcript = true;

        this.RegnNo =
          res.data[0].StuPRN;

        this.clgName =
          res.data[0].College;

        this.CoName =
          res.data[0].Course;

        this.StuName =
          res.data[0].StuName;
        if (this.data.FeeType === 'ATTFE' || this.data.FeeType === 'VOD') {

          this.payHistoryData = [];

          const copies =
            Number(
              this.TranscriptData.StuCertCopies
            ) || 0;

          const deliveryOpt =
            this.TranscriptData.DeliveryOpt;

          const BASE_AMOUNT = 3050;

          // Attestation/VOD Fee Per Copy - VOD has no copies fee
          const PER_COPY_FEE = this.isVOD ? 0 : 800;
          const SOFT_COPY_FEE = 800;
          const HARD_COPY_FEE = 2570;
          // Hard Copy Delivery Charges Per Copy - VOD has no per copy delivery
          const PER_COPY_DELIVERY = this.isVOD ? 0 : 800;

          // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
          const isIndiaStudent = this.isVOD ? this.isStudentWithinIndia() : false;

          let copiesFee = 0;

          let softCopy = 0;

          let hardCopy = 0;

          let perCopyDelivery = 0;

          let postalCharges = 0;

          let totalFee = 0;

          copiesFee =
            PER_COPY_FEE * copies;

          if (deliveryOpt === 'Soft') {

            softCopy =
              SOFT_COPY_FEE;

            postalCharges =
              softCopy;

          }

          else if (deliveryOpt === 'Hard') {

            // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
            hardCopy =
              (this.isVOD && isIndiaStudent) ? 0 : HARD_COPY_FEE;

            perCopyDelivery =
              (this.isVOD && isIndiaStudent) ? 0 : (PER_COPY_DELIVERY * copies);

            postalCharges =
              hardCopy +
              perCopyDelivery;

          }

          else if (deliveryOpt === 'Both') {

            softCopy =
              SOFT_COPY_FEE;

            // VOD: when DeliverAt is "IN" (within India) do not apply By Air Mail Charges / per-copy delivery
            hardCopy =
              (this.isVOD && isIndiaStudent) ? 0 : HARD_COPY_FEE;

            perCopyDelivery =
              (this.isVOD && isIndiaStudent) ? 0 : (PER_COPY_DELIVERY * copies);

            postalCharges =
              softCopy +
              hardCopy +
              perCopyDelivery;

          }

          totalFee =
            BASE_AMOUNT +
            copiesFee +
            postalCharges;

          this.TotalPaidAmount =
            totalFee;

          this.convert(
            this.TotalPaidAmount
          );
          const paymentDate =
            new Date();
          // BASE AMOUNT

          this.payHistoryData.push({

            FeeHead: this.isVOD ? 'Verification Fee' : 'Base Amount',

            FeeAmt: BASE_AMOUNT,

            FeePaymentDate: paymentDate

          });

          // COPIES FEE - Only for ATTFE, not for VOD
          if (!this.isVOD && copiesFee > 0) {
            this.payHistoryData.push({

              FeeHead:
                `Copies Fee (${copies} Set)`,

              FeeAmt: copiesFee,

              FeePaymentDate: paymentDate

            });
          }
          
          // For VOD, show Copies Fee as Not Applicable
          if (this.isVOD) {
            this.payHistoryData.push({

              FeeHead:
                'Copies Fee',

              FeeAmt: 0,

              FeePaymentDate: paymentDate

            });
          }

          // SOFT COPY

          if (softCopy > 0) {

            this.payHistoryData.push({

              FeeHead: this.isVOD ? 'By Email Charges' : 'Soft Copy Delivery Fee',

              FeeAmt: softCopy,

              FeePaymentDate: paymentDate

            });

          }

          // HARD COPY

          if (hardCopy > 0) {

            this.payHistoryData.push({

              FeeHead: this.isVOD ? 'By Air Mail Charges' : 'Hard Copy Delivery Fee',

              FeeAmt: hardCopy,

              FeePaymentDate: paymentDate

            });

          }

          // HARD COPY DELIVERY

          if (perCopyDelivery > 0) {

            this.payHistoryData.push({

              FeeHead: this.isVOD ? 'Extra Hard Copy Delivery Charges' : 'Extra Hard Copy Delivery Charges',

              FeeAmt: perCopyDelivery,

              FeePaymentDate: paymentDate

            });

          }

          // // POSTAL CHARGES

          // if (postalCharges > 0) {

          //   this.payHistoryData.push({

          //     FeeHead:
          //       'Postal Charges',

          //     FeeAmt: postalCharges,

          //     FeePaymentDate: paymentDate

          //   });

          // }

          const customOrder = this.isVOD ? [

            'Verification Fee',

            'Copies Fee',

            'By Email Charges',

            'By Air Mail Charges',

            'Extra Hard Copy Delivery Charges',

            // 'Postal Charges'

          ] : [

            'Base Amount',

            'Copies Fee',

            'Soft Copy Delivery Fee',

            'Hard Copy Delivery Fee',

            'Extra Hard Copy Delivery Charges',

            // 'Postal Charges'

          ];

          this.payHistoryData.sort((a, b) => {

            const idxA =
              customOrder.findIndex(x =>
                a.FeeHead.includes(x));

            const idxB =
              customOrder.findIndex(x =>
                b.FeeHead.includes(x));

            return (
              (idxA === -1
                ? customOrder.length
                : idxA) -
              (idxB === -1
                ? customOrder.length
                : idxB)
            );

          });

          console.log(
            'Copies Fee => ',
            copiesFee
          );

          console.log(
            'Soft Copy Fee => ',
            softCopy
          );

          console.log(
            'Hard Copy Fee => ',
            hardCopy
          );

          console.log(
            'Hard Copy Delivery => ',
            perCopyDelivery
          );

          console.log(
            'Postal Charges => ',
            postalCharges
          );

          console.log(
            'Total Fee => ',
            totalFee
          );

        }

      }

    });

}


}